import { render, staticRenderFns } from "./CursosProgramados.vue?vue&type=template&id=31397e9a&scoped=true"
import script from "./CursosProgramados.vue?vue&type=script&lang=js"
export * from "./CursosProgramados.vue?vue&type=script&lang=js"
import style0 from "./CursosProgramados.vue?vue&type=style&index=0&id=31397e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31397e9a",
  null
  
)

export default component.exports